import { ChevronDownIcon, StarIcon } from 'lucide-react'

import { type FlatAllowanceApproach } from 'apps/employer_renewals/types'
import { DropdownMenu, TextButton } from 'slab'

type Props = {
  flatAllowanceApproach: FlatAllowanceApproach
  onFlatAllowanceApproachChange: (flatAllowanceApproach: FlatAllowanceApproach) => void
}

const approachTexts: Record<FlatAllowanceApproach, string> = {
  recommended: 'Recommended',
  current: 'Current allowances',
  custom: 'Custom allowances',
}

export default function FlatAllowanceApproachSelect ({ flatAllowanceApproach, onFlatAllowanceApproachChange }: Props) {
  return (
    <DropdownMenu
      trigger={
        <div>
          <TextButton
            color='purple'
            leftIcon={flatAllowanceApproach === 'recommended' ? StarIcon : undefined}
            rightIcon={ChevronDownIcon}
          >
            {approachTexts[flatAllowanceApproach]}
          </TextButton>
        </div>
      }
    >
      <DropdownMenu.Item onSelect={() => onFlatAllowanceApproachChange('recommended')}>
        <div className='flex items-center gap-2'>
          <div className='text-thatch-purple'><StarIcon size={16} /></div>
          {approachTexts.recommended}
        </div>
      </DropdownMenu.Item>
      <DropdownMenu.Item onSelect={() => onFlatAllowanceApproachChange('custom')}>
        {approachTexts.custom}
      </DropdownMenu.Item>
      <DropdownMenu.Item onSelect={() => onFlatAllowanceApproachChange('current')}>
        {approachTexts.current}
      </DropdownMenu.Item>
    </DropdownMenu>
  )
}
